import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/generales/services/toast.service';
import { PublicityService } from 'src/app/services/publicity.service';
import { environment } from 'src/environments/environment';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';
import { UploadImgComponent } from '../upload-img/upload-img.component';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss'],
})
export class DashboardAdminComponent implements OnInit {
  coverPhoto: any[] = [];
  url: string = environment.url;
  constructor(
    private publicitySv: PublicityService,
    private translate: TranslateService,
    private alertController: AlertController,
    private uiSv: UiService,
    private toastService: ToastService,
    private adminSv: AdminServiceService
  ) { }

  ngOnInit() {
    this.getBanners();
  }

  getBanners(){
    this.coverPhoto = [];
    this.adminSv.allBanner().subscribe((data: any) => {
      const sliderHome: any[] = data.data.data; 
      sliderHome.forEach(item => {
        this.coverPhoto.push(
          { 
            img: `${this.url}/file/publicity/${item.file}`, 
            id: item?.id,
            action: item.action
          }
        )
      })
    })
  }

  async onFileSelected(ev) {
    if(!ev.target.files[0].type) return;
    if(
      ev.target.files[0].type.includes('png') ||
      ev.target.files[0].type.includes('jpeg') || 
      ev.target.files[0].type.includes('jpg') ||
      ev.target.files[0].type.includes('webp')
      ){
        const files = ev.target.files;
        if(files.length > 6){
          this.uiSv.presentAlert('Alerta', 'Solo puedes seleccionar un maximo de 6 imagenes');
          return true;
        }
        for(const file of files){
          const reader = new FileReader();
          const formData = new FormData();
          formData.set('typeId', '1');
          formData.set('positionId', '1');
          formData.set('file', file);
          formData.set('action', file);
          reader.readAsDataURL(file);
          let img: any = {}
          reader.onload = async e => {
            img = {
              img: e.target.result,
              featured: 0,
              file: file,
            };
            const { data } = await this.uiSv.createModal(UploadImgComponent,
              { img: img.img, canClose: false });
            formData.set('action', data);
            const res: any = await this.publicitySv.postPublicity(formData);
            img.id = res?.data?.id;
            this.coverPhoto.push(img);
          }
        }
      }else{
        return this.toastService.show('Selecciona una imagen valida');
      }
  }

  async deleteImg(deletingImg){
    const alert = await this.alertController.create({
      header: this.translate.instant('SENTENSES.ELIMINAR_IMAGEN'),
      message: deletingImg?.store_front 
      ? this.translate.instant('SENTENSES.ANTES_DE_ELIMINAR_UNA_FOTO_DESTACADA_DEBES_SELECCIONAR_OTRA') 
      : this.translate.instant('SENTENSES.ESTAS_SEGURO_QUE_DESEAS_ELIMINAR_ESTA_IMAGEN'),
      buttons: [
        {
          text: this.translate.instant('WORDS.ACEPTAR'),
          role: 'accept',
          handler: async () => {
            if(this.coverPhoto.length > 1){
              this.postDelete(deletingImg.id);
            }else{
              this.uiSv.presentAlert('Alerta', 'Antes debes subir otra imagen para borrar esta')
            }
          }
        },
        {
          text: this.translate.instant('WORDS.CANCELAR'),
          role: 'cancel'
        }
      ]
    });

    alert.present();
  }

  async editImg(img){
    const formData = new FormData();
    const { data } = await this.uiSv.createModal(UploadImgComponent,
      { img: img.img, action: img.action });
    if(data === 'close'){
      return false;
    }
    formData.set('action', data);
    formData.set('id', img.id);
    await this.publicitySv.postPublicity(formData, 'update');
    this.getBanners()
  }

  async postDelete(id){
    try{
      // idimg
      // state = 0
      const body = {
        id,
        state: 0
      };
  
      await this.publicitySv.deletePublicity(body);
      this.coverPhoto = this.coverPhoto.filter(item => item.id !== id);
      return true;
    }catch(err){
      return false;
    }
  }
}
